import styles from '../sass/sfl.scss';

/**************************************************************************************************************************
 **************************************************************************************************************************
 ************             *************************************************************************************************
 *************           **************************************************************************************************
 **************         ***************************************************************************************************
 ***************       ****************************************************************************************************
 ****************     *****************************************************************************************************
 *****************   ******************************************************************************************************
 **************************************************************************************************************************
 **************************************************************************************************************************/

 /***************************************
    Fonctions JS vanille pour la manipulation de classe CSS
****************************************/
var hasClass, addClass, removeClass, toggleClass;

if ('classList' in document.documentElement) {
    hasClass = function(el, className) { return el.classList.contains(className); };
    addClass = function(el, className) { el.classList.add(className); };
    removeClass = function(el, className) { el.classList.remove(className); };
} else {
    hasClass = function(el, className) {
        return new RegExp('\\b' + className + '\\b').test(el.className);
    };
    addClass = function(el, className) {
        if (!hasClass(el, className)) { el.className += ' ' + className; }
    };
    removeClass = function(el, className) {
        el.className = el.className.replace(new RegExp('\\b' + className + '\\b', 'g'), '');
    };
}

toggleClass = function(el, className) {
    hasClass(el, className) ? removeClass(el, className) : addClass(el, className);
}

/***************************************
    Ajout de la classe admin si connecté
****************************************/
var detectIfUserIsConnected = function() {
    if (document.getElementsByClassName("admin-links").length !== 0) {
        document.body.classList.add("admin");
    }
}

/***************************************
    Transformation de date en écart de date
            année actuelle - date
****************************************/
var reformatDateDiff = function() {
    var strYearDate = document.getElementsByClassName('diffDate') || [];

    for (var i = 0; i < strYearDate.length; i++) {
        strYearDate[i].innerText = (new Date()).getFullYear() - parseInt(strYearDate[i].innerText);
    }
}

/***************************************
 Get cookie by name
 ****************************************/
var getCookie = function (cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

/***************************************
    Ajout d'attribut sur les liens externes
****************************************/
var addAttrToExternalLinks = function() {
    var anchorEls = document.querySelectorAll('#main-content a');

    for (var i = 0; i < anchorEls.length; i++) {
        var anchorEl = anchorEls[i];
        var href = anchorEl.getAttribute('href') || "";

        if (href.indexOf(window.location.host) === -1 && href.indexOf('http') === 0) {

            var hasImgNode = false;

            for (var j = 0; j < anchorEl.childNodes.length; j++) {
                if (anchorEl.childNodes[j].nodeName === "IMG")
                    hasImgNode = true;
            }

            if (!hasImgNode) {

                anchorEl.setAttribute('target', '_blank');
                anchorEl.setAttribute("data-trigger", "hover focus");
                anchorEl.setAttribute("data-placement", "bottom");
                anchorEl.setAttribute("data-toggle", "tooltip");
                anchorEl.setAttribute("role", "button");
                anchorEl.setAttribute("data-html", "true");

                if (anchorEl.className === '')
                    anchorEl.classList.add('lien-externe');
            }


            if (document.getElementsByTagName('html')[0].getAttribute("lang").indexOf('fr') === 0) {
                anchorEl.insertAdjacentHTML('beforeend', '<span class="sr-only" lang="fr"> &nbsp;, Ce lien vous redirigera vers un site externe.</span>');
                anchorEl.setAttribute("data-content", "Ce lien vous redirigera vers un site externe.");
            } else {
                anchorEl.insertAdjacentHTML('beforeend', '<span class="sr-only" lang="en"> &nbsp;, You will be redirected to an external website.</span>');
                anchorEl.setAttribute("data-content", "You will be redirected to an external website.");
            }
        }
    }
}

/***************************************
    Cacher le menu lorsqu'on clique dehors
****************************************/
var hideMenuOnMouseUp = function() {
    $(document).mouseup(function(e) {
        var container = $(".main-nav-container .dropdown.dropdown-open .dropdown-menu");
        var theAnchorRelated = $(".main-nav-container .dropdown.dropdown-open a.dropdown-toggle");
        if (!container.is(e.target) && container.has(e.target).length === 0 &&
            !theAnchorRelated.is(e.target) && theAnchorRelated.has(e.target).length === 0) {
            $(".main-nav-container .dropdown.dropdown-open a.dropdown-toggle").trigger("click");
        }
    });
}

/***************************************
    Pour fermer un popover avec la tabulation
****************************************/
var closePopoverOnTab = function() {
    $("button[data-toggle='popover']").on('inserted.bs.popover', function() {
        $('p.small').on("blur", function() {
            $(this).closest($('button[data-toggle="popover"]').popover('hide'));
        })
    })

    //Pour fermer un dropdown avec la tabulation
    $('.dropdown').on('shown.bs.dropdown', function() {
        var lastItem = $(this).find('.dropdown-menu > li:last-child a');
        lastItem.attr('tabindex', '0');
        lastItem.on("blur", function() {
            $(this).dropdown('toggle');
        })
    })
}

/***************************************
    Affichage du menu secondaire en format mobile
****************************************/
var secondaryMenuMobileSetup = function() {
    var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    if (viewportWidth < 768) {
        $('.sec-nav .dropdown-toggle').dropdown({ display: 'static' });
    }
    // Selectionne le noeud dont les mutations seront observées
    var targetNode = document.getElementById('main-content');

    // Options de l'observateur (quelles sont les mutations à observer)
    var config = { attributes: false, childList: true, subtree: true };

    // Fonction callback à éxécuter quand une mutation est observée
    var callback = function(mutationsList) {
        jQuery("[data-toggle=tooltip]").popover();
    };

    // Créé une instance de l'observateur lié à la fonction de callback
    var observer = new MutationObserver(callback);

    // Commence à observer le noeud cible pour les mutations précédemment configurées
    observer.observe(targetNode, config);

    // L'observation peut être arrêtée par la suite
    // observer.disconnect();
}

/***************************************
    Instantiation de l'affichage des avis
****************************************/
var noticeSetup = function() {
    if (window.sessionStorage.showAvis !== "false") {
        var notificationContainer = document.getElementById("notificationContainer");
        if (notificationContainer) {
            notificationContainer.classList.remove("hide");
            window.sessionStorage.showAvis = true;
        }
    }

    var btnCloseAvis = document.getElementById("btnCloseAvis");
    if (btnCloseAvis) {
        btnCloseAvis.addEventListener("click", function() {

            var notificationContainer = document.getElementById("notificationContainer");

            if (notificationContainer) {
                notificationContainer.classList.add("hide");
                window.sessionStorage.showAvis = false;
            }
        });
    }

    var btnCloseAvisProvince = document.getElementById("btnCloseAvisProvince");
    if (btnCloseAvisProvince) {
        btnCloseAvisProvince.addEventListener("click", function() {

            var avisProvinceContainer = document.getElementById("avis-province-container");

            if (avisProvinceContainer) {
                addClass(avisProvinceContainer, "hide");
            }
        });
    }

    // Convert cookie str to object
    let getStrObj = function (str, objSep, objValSep) {
        let obj = {},
            i,
            KeyVal = str.split(objSep);
        for (i in KeyVal) {
            KeyVal[i] = KeyVal[i].split(objValSep);
            obj[KeyVal[i][0]] = KeyVal[i][1];
        }
        return obj;
    }

    // Get consent cookies values
    let getOptanonConsentObj = function () {
        let optanonConsentStr = getCookie("OptanonConsent");
        let optanonConsentObj = getStrObj(optanonConsentStr, "&", "=");
        let cookiesGroupsStr = decodeURIComponent(optanonConsentObj.groups);
        let cookiesGroupsObj = getStrObj(cookiesGroupsStr, ",", ":");
        return cookiesGroupsObj;
    };

    // Set province cookie once
    (function() {
        let OptanonConsentObj = getOptanonConsentObj();
        if (OptanonConsentObj['C0003'] === '1'){
            if (document.cookie.indexOf("provinceConfirmee=") < 0) {
                document.cookie = "provinceConfirmee=true; expires=Fri, 31 Dec 9999 23:59:59 GMT";
            }
        }
    })();

}

/************************************************ 
    Affichage des Popup de Média Sociaux
************************************************/
var socialMediaPopup = function(event){
    function openSharedScreen(event) {
        event.preventDefault();

        var targetUrl = this.href;
        var winSize;
        var socialNetwork;

        switch (this.id) {
            case "share-linkedin":
                winSize = [450, 300];
                socialNetwork = "LinkedIn";
                break;
            case "share-twitter":
                winSize = [450, 300];
                socialNetwork = "Twitter";
                break;
            default:
                winSize = [450, 300];
                socialNetwork = "Facebook";
        }

        window.open(targetUrl, "_blank", "width=" + winSize[0] + ",height=" + winSize[0]);

        dataLayer.push({
            'event': 'social',
            'socialNetwork': socialNetwork,
            'socialAction': 'Share',
            'socialTarget': document.location
        });
    }

    var btnShare = document.querySelectorAll(".btnSharePage");

    for (var i = 0; i < btnShare.length; i += 1) {
        btnShare[i].addEventListener('click', openSharedScreen, false);
    }
}
    
/************************************************ 
    Configuration de la barre de recherche
************************************************/
var searchBoxSetup = function() {
    function searchBox(e) {
        e.preventDefault();

        var itemsListUtil = document.querySelectorAll(".nav-utilitaire > li");

        if (e.currentTarget.classList.contains("btnSearch-open")) {
            document.getElementsByClassName("search-ctrl")[0].classList.remove("hidden");
        } else {
            document.getElementsByClassName("search-ctrl")[0].classList.add("hidden");
        }
        for (var i = 0; i < itemsListUtil.length; i += 1) {
            if (e.currentTarget.classList.contains("btnSearch-open")) {
                itemsListUtil[i].classList.add("searchOpen");
            } else {
                itemsListUtil[i].classList.remove("searchOpen");
            }
        }
    }

    var btnSearch = document.querySelectorAll(".btnSearch-open");

    for (var i = 0; i < btnSearch.length; i += 1) {
        btnSearch[i].addEventListener('click', searchBox, false);
    }

    var btnClose = document.querySelectorAll(".btnSearch-close");

    for (var i = 0; i < btnClose.length; i += 1) {
        btnClose[i].addEventListener('click', searchBox, false);
    }
};

/************************************************ 
    Init search collapse and close search button in the header for accessibility
************************************************/
var accessibilitySetup = function() {

    var searchToggles = document.querySelectorAll('.search-toggle');
    var searchInput = document.getElementById('zoneRecherchePage');

    Array.prototype.forEach.call(searchToggles, function(searchToggle) {
        searchToggle.addEventListener('click', function() {
            if (this.getAttribute('aria-expanded') === "false") {
                setTimeout(function() {
                    searchInput.focus()
                }, 300);
            }
        });
    });

    var searchClose = document.querySelector('.close-searchbar');
    var mediaQuery = window.matchMedia("(min-width: 768px)");

    if(searchClose != null){
        searchClose.addEventListener('click', function() {
            var searchToggleTarget;

            if (mediaQuery.matches) {
                searchToggleTarget = document.querySelector(".sub-header .search-toggle");
            } else {
                searchToggleTarget = document.querySelector(".main-header .search-toggle");
            }

            setTimeout(function() {
                searchToggleTarget.focus()
            }, 300);

        });
    }
};

/************************************************ 
    Redundant JS click for blog and aria-describedby for accessibility
************************************************/
var blogItemsSetup = function() {
    editBlogItems = function() {
        var blogList = document.querySelectorAll('.blog-item');
        Array.prototype.forEach.call(blogList, function(blogItem) {
            var uniq =  (crypto.getRandomValues(new Uint32Array(1))[0] / 4294967295).toString(36).substring(2, 11);
            var blogCta = blogItem.querySelector('.blog-cta'),
                blogCtaId = "blogCTA_" + uniq;
            var down,
                up,
                blogLink = blogItem.querySelector('a.blog-link');
            var metricExtraText = !hasClass(blogItem, "blog-video") ? "Article: " : "";

            // Redundant JS click
            blogItem.style.cursor = 'pointer';
            blogItem.onmousedown = function() { down = +new Date(); }
            blogItem.onmouseup = function(event) {
                up = +new Date();
                if ((up - down) < 200 && event.which === 1) {
                    dataLayer.push({
                        'event': 'interractionsPages',
                        'category': 'Action',
                        'action': 'Clic',
                        'label': metricExtraText + blogLink.innerText,
                        'value': 0,
                        'nonInteraction': false
                    });

                    if (blogLink !== event.target) {
                        blogLink.click();
                    }
                }
            };

            // Add aria-describedby with a randomized ID
            blogCta.setAttribute('id', blogCtaId);
            blogLink.setAttribute('aria-describedby', blogCtaId);

        });
    }
    var blogMethodReady = new CustomEvent('blogMethodReady');
    // Dispatch the event
    document.dispatchEvent(blogMethodReady);

    editBlogItems();
};

// Modified version of Equal height (https://github.com/jacobwarduk/equal-heights/blob/develop/src/simple-equal-heights.js)
// Example usage use data-match-height="groupName" on anything!!!
// Example for desktop only, add "desktop-" prefix for the attribute data-match-height="desktop-groupName" on anything!!!

var matchHeight = (function() {

    var prefixDesktop = "desktop-",
        minWidthDesktop = window.matchMedia("(min-width: 768px)");

    var init = function() {
        eventListeners();
        match();
    };

    var eventListeners = function() {
        var resizeTimer;

        window.onresize = function() {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(match, 250);
        };
    }

    var match = function() {
        var groupName = Array.prototype.slice.call(document.querySelectorAll("[data-match-height]"));
        var groupHeights = {};

        for (var i = 0; i < groupName.length; i++) {
            var currentItem = groupName[i];
            var data = currentItem.getAttribute("data-match-height");
            currentItem.style.minHeight = "auto";

            if (groupHeights.hasOwnProperty(data)) {
                Object.defineProperty(groupHeights, data, {
                    value: Math.max(groupHeights[data], currentItem.offsetHeight),
                    configurable: true,
                    writable: true,
                    enumerable: true
                });
            } else {
                groupHeights[data] = currentItem.offsetHeight;
            }
        }

        var groupHeightsMax = groupHeights;

        Object.getOwnPropertyNames(groupHeightsMax).forEach(function(value) {
            var elementsToChange = document.querySelectorAll("[data-match-height='" + value + "']");
            var isDesktopOnly = value.indexOf(prefixDesktop, 0) == 0;

            if (!isDesktopOnly || (isDesktopOnly && minWidthDesktop.matches)) {
                for (var i = 0; i < elementsToChange.length; i++) {
                    elementsToChange[i].style.minHeight = Object.getOwnPropertyDescriptor(groupHeightsMax, value).value + "px";
                }
            }
        });
    };

    return {
        init: init
    }
})();

var backToTop = (function() {
    var init = function() {
        $(window).scroll(function() {
            if ($(this).scrollTop() >= 50) { // If page is scrolled more than 50px
                $('#back-to-top').fadeIn(200); // Fade in the arrow
            } else {
                $('#back-to-top').fadeOut(200); // Else fade out the arrow
            }
        });
        $('#back-to-top').click(function() { // When arrow is clicked
            $('body,html').animate({
                scrollTop: 0 // Scroll to top of body
            }, 500);
        });
    };

    return {
        init: init
    }
})();

// Function to move content based on media query from one container to another
var moveContentWithMQ = function() {
    var baseMQ = window.matchMedia("(min-width: 768px)");

    var getContext = function getContext() {
        var isDesktop = void 0;

        if (baseMQ.matches) {
            isDesktop = true;
        } else {
            isDesktop = false;
        }
        return isDesktop;
    };

    var eventListeners = function eventListeners() {
        baseMQ.addListener(moveContent);
    };

    var openProvinceMobile = function openProvinceMobile() {

        var btnChangeProvince = document.getElementById('btnChangeProvince');
        
        if(btnChangeProvince) {
            
            btnChangeProvince.addEventListener('click', function() {

                var isDesktop = getContext();

                var menuProvince = this.nextElementSibling;

                if (!isDesktop && menuProvince.style.display == "block") {
                    this.setAttribute("aria-expanded", "false");
                    menuProvince.style.display = "";
                } else if (!isDesktop) {
                    this.setAttribute("aria-expanded", "true");
                    menuProvince.style.display = "block";
                }
            });
        }
    }

    var moveContent = function moveContent() {
        var isDesktop = getContext();

        // Fermeture de menu de sélection de province
        var btnChangeProvince = document.getElementById('btnChangeProvince');
        
        if(btnChangeProvince) {
            btnChangeProvince.nextElementSibling.style.display = "";
        }

        var groupName = Array.prototype.slice.call(document.querySelectorAll("[data-move-content-mq]"));

        for (var i = 0; i < groupName.length; i++) {
            var currentItem = groupName[i];
            var data = currentItem.getAttribute("data-move-content-mq");
            var itemName = data.substr(0, data.indexOf('--'));

            if (isDesktop && data.indexOf("--mobile") !== -1) {
                var targetDesktop = document.querySelector("[data-move-content-mq=" + itemName + "--desktop]");

                while (currentItem.childNodes.length > 0) {
                    targetDesktop.appendChild(currentItem.childNodes[0]);
                }
            } else if (!isDesktop && data.indexOf("--desktop") !== -1) {
                var targetMobile = document.querySelector("[data-move-content-mq=" + itemName + "--mobile]");

                while (currentItem.childNodes.length > 0) {
                    targetMobile.appendChild(currentItem.childNodes[0]);
                }

            }
        }
    };

    var init = function init() {
        moveContent();
        eventListeners();
        openProvinceMobile();
    };

    return {
        init: init
    };
}();

var mainMenu = (function() {
    var baseMQ = window.matchMedia("(min-width: 768px)");

    var pushAnalytics = function(action, label) {
        dataLayer.push({
            'event': 'interractionsPages',
            'category': 'Onglet-principal',
            'action': action,
            'label': label,
            'value': 0,
            'nonInteraction': false
        });
    }

    var init = function(menuId) {
        var $mainMenu = document.getElementById(menuId);
        N3.menuburger.init($mainMenu);
        menuResponsiveSwitch();
        baseMQ.addListener(menuResponsiveSwitch);

        var $menuDropdownToggles = document.querySelectorAll(".main-nav .dropdown-toggle");
        for (var i = 0; i < $menuDropdownToggles.length; i++) {
            $menuDropdownToggles[i].addEventListener('click', function(event) {
                event.preventDefault();

                if (this.getAttribute("aria-expanded") === "true")
                    pushAnalytics("Ouverture d'un onglet principal", this.innerText);
                else {
                    pushAnalytics("Fermeture d'un onglet principal", this.innerText);
                }
            })
        }

        function menuResponsiveSwitch() {
        
            if ($mainMenu) {

                var $menuDropdowns = document.querySelectorAll(".main-nav > .dropdown");

                if (!baseMQ.matches) {
                    $mainMenu.setAttribute("aria-hidden", true);
                    $mainMenu.setAttribute("class", "navburger");

                    for (var i = 0; i < $menuDropdowns.length; i++) {
                        addClass($menuDropdowns[i], "dropdown-static");
                    }
                } else {
                    N3.menuburger.hide();
                    window.setTimeout(function() {
                        $mainMenu.removeAttribute("style");
                    }, 300);

                    $mainMenu.setAttribute("aria-hidden", false);
                    $mainMenu.setAttribute("class", "navdesktop");

                    for (var i = 0; i < $menuDropdowns.length; i++) {
                        removeClass($menuDropdowns[i], "dropdown-static");
                    }
                }
            }
        }
    }
    return {
        init: init
    }
})();

/**
 * VALIDATION DE FORMULAIRE CÔTÉ CLIENT
 */
var validatorDefault = (function() {

    var init = function() {
        if ($.validator) {
            function getErrorText(element, validator, i, id) {
                //trouver les names de chaque erreur
                var name = $(validator.errorList[i].element).attr("name");

                var errorText = "";
                // si l'objet summaries existe je vais prendre les erreurs dans cet objet
                if (validator.settings.summaries) {
                    var keys = Object.keys(validator.settings.summaries);
                    var key = undefined;
                    for (var j = 0; j < keys.length; j++) {
                        if (keys[j] === name) {
                            key = name;
                            break;
                        }
                    }

                    if (key) {
                        var methodeValidation = validator.errorList[i].method;
                        if (typeof validator.settings.summaries[key] === "object") {
                            errorText = validator.settings.summaries[key][methodeValidation];
                        } else {
                            errorText = validator.settings.summaries[key];
                        }
                    }
                }

                // si pour une raison ou une autres j'ai n'ai pas cette erreure definie
                // je vais le chercher dans les messages d'erreur pas défaut
                if (errorText == "" || errorText == undefined) {
                    //desfois ces des legend, desfois c'est des label...donc j'ai ajouté un * pour tous les trouver
                    errorText = $(element)
                        .find("*[for='" + id + "']")
                        .text();
                }

                //si le for est vide ou pas défini, j'ajoute le texte : "erreur"
                if (errorText == "" || errorText == undefined) {
                    var otherErrorText = $(element)
                        .find("*[for='" + name + "']")
                        .text();

                    // legend ne peut pas avoir un for=''. Pour cela nous allons considerer un data-for=''
                    if (otherErrorText == "" || otherErrorText == undefined) {
                        otherErrorText = $(element)
                            .find("*[data-for='" + name + "']")
                            .text();
                    }

                    errorText = otherErrorText === "" || otherErrorText === undefined ? "Erreur" : otherErrorText;
                }
                return errorText;
            }
            $.validator.setDefaults({
                onfocusout: false,
                focusInvalid: false,
                errorElement: "span",
                errorPlacement: function(error, element) {
                    var elType = element.get(0).type;

                    if (elType == "checkbox" || elType == "radio") {
                        error.insertBefore(element.closest("." + elType)).addClass("help-block");
                    } else {
                        error.insertBefore(element).addClass("help-block");
                    }
                },
                highlight: function(element, errorClass) {
                    $(element)
                        .closest(".form-group")
                        .addClass("has-error");
                },
                unhighlight: function(element, errorClass) {
                    $(element)
                        .closest(".form-group")
                        .removeClass("has-error");
                },
                invalidHandler: function(event, validator) {
                    $(this)
                        .find(".help-block")
                        .removeClass("hidden");
                    if ($(this).find(".error-group ul").length) {
                        $(this)
                            .find(".error-group ul li")
                            .remove();
                    } else {
                        $(this)
                            .find(".error-group")
                            .append("<ul></ul>");
                    }

                    //for les errorList en paramettre
                    for (var i = 0; i < validator.errorList.length; i++) {
                        //trouver les ID de chaque erreur
                        var id = $(validator.errorList[i].element).attr("id");
                        var errorText = getErrorText($(this), validator, i, id);

                        //garnir une liste pour chaque erreur trouver
                        $(this)
                            .find(".error-group ul")
                            .append("<li><a href=#" + id + ">" + errorText + "</li>");
                        $(this)
                            .find(".error-group p")
                            .focus();
                    }
                },

                showErrors: function(errorMap, errorList) {
                    var validator = this;
                    // Boite d'erreurs et lien
                    this.defaultShowErrors();
                    var $currentForm = $(this.currentForm);
                    //ce code est utilisé pour remettre une erreur dans la liste sur le onChange
                    //si l'object n'est pas vide, il y a une erreur après le onChange
                    if (jQuery.isEmptyObject(errorList) == false) {
                        var id = $(errorList[0].element).attr("id");
                        //desfois ces des legend, desfois c'est des label...donc j'ai ajouté un * pour tous les trouver
                        var errorText = "";

                        //for les errorList en paramettre
                        for (var i = 0; i < errorList.length; i++) {
                            errorText = getErrorText($currentForm, validator, i, id);
                        }

                        //si l'erreur ne fait pas déjà partie de la liste
                        if (!$currentForm.find('.error-group ul a[href$="' + id + '"]').length) {
                            //si le helpblock a été enlevé, rajoute le
                            if ($currentForm.find(".help-block").hasClass("hidden")) {
                                $currentForm.find(".help-block").removeClass("hidden");
                            }
                            //rajoute le ul qui a été enlevé
                            if (!$(this.currentForm).find(".error-group ul").length) {
                                $(this.currentForm)
                                    .find(".error-group")
                                    .append("<ul></ul>");
                            }
                            //apprend le message d'erreur
                            $currentForm.find(".error-group ul").append("<li><a href=#" + id + ">" + errorText + "</li>");
                        }
                        //lorsque tu cliques sur un erreur qui s'affiche avec le plugin, il va scroller vers le label
                        $currentForm.find(".error-group a").on("click", function(event) {
                            event.preventDefault();
                            var id = $(this).attr("href");
                            //+5 est pour du padding
                            var offset =
                                $(id)
                                .parents(".form-group")
                                .find(".help-block")
                                .outerHeight() + 5;
                            $(id).focus();
                            //anime le scroll vers le label error
                            $("html, body").animate({
                                    scrollTop: $(id).offset().top - offset - 10
                                },
                                300
                            );
                        });
                    }
                    //si l'object this.invalid est vide (pas d'erreur), enleve le help-block
                    if (jQuery.isEmptyObject(this.invalid)) {
                        $currentForm.find(".help-block").addClass("hidden");
                    }
                    //si l'erreur a été réparé, enleve le de la liste.
                    for (var i = 0; i < this.successList.length; i++) {
                        var id = $(this.successList[i]).attr("id");
                        $currentForm
                            .find('.error-group a[href$="' + id + '"]')
                            .parents("li")
                            .remove();
                    }

                    //voir si le formulaire est valide
                    var isValid = true;
                    $.each($(this.currentForm).validate().invalid, function(index, value) {
                        if (value != false) {
                            isValid = false;
                        }
                    });

                    //si le formulaire est valide enlève ul et enlève help-block
                    if (jQuery.isEmptyObject($(this.currentForm).validate().invalid) || isValid == true) {
                        $(this.currentForm)
                            .find(".error-group ul")
                            .remove();
                        $(this.currentForm)
                            .find(".help-block")
                            .addClass("hidden");
                    }
                }
            });
            $.validator.addMethod("canadianDate", function(value, element) {
                return value.match(/^\d{2}\-\d{2}-\d{4}$/);
            });
        }
    }

    return {
        init: init
    }
})();

var fixGalleryItems = function() {
    var divs = $(".gallery-item-title").closest(".col-sm-8");
    for (var i = 0; i < divs.length; i += 3) { 
        divs.slice(i, i + 3).wrapAll("<div class='row'></div>"); 
    }
}

var setup = function(){
    detectIfUserIsConnected();
    reformatDateDiff();
    addAttrToExternalLinks();
    hideMenuOnMouseUp();
    secondaryMenuMobileSetup();
    noticeSetup();
    socialMediaPopup();
    searchBoxSetup();
    accessibilitySetup();
    blogItemsSetup();
    fixGalleryItems();
    closePopoverOnTab();

    mainMenu.init("mainMenu");
    matchHeight.init();
    moveContentWithMQ.init();
    backToTop.init();
    validatorDefault.init();
}

// Initialising on DOM load
document.addEventListener("DOMContentLoaded", function() {
    setup();
});

// Initialising on SPA endNavigate
Liferay.on('SPAReady', function (event) {
   Liferay.SPA.app.on('endNavigate', function(event) {
       setup(); 
       $("html").removeClass("lfr-spa-loading");
   });
});


//////////////////
// WEBPACK FOOTER
// ./src/js/sfl.js
// module id = 21
// module chunks = 2